export class AwsCredentialProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsCredentialProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
